import { Box, Tooltip, Typography } from '@mui/material';
import { ReactComponent as ImageSparkIcon } from '../assets/header-icons/ai-image-spark.svg';

function RewardProgress({ current, total }) {
  const threshold = Number.isFinite(total) && total > 0 ? total : 3600;
  const earned = Number.isFinite(current) ? Math.min(Math.max(current, 0), threshold) : 0;
  const remaining = threshold - earned;
  const percent = (earned / threshold) * 100;
  const description = `${remaining.toLocaleString()} points to next image`;

  return (
    <Tooltip title={description}>
      <Box sx={{
        display: 'grid',
        gridTemplateRows: 'var(--score-label-height, 24px) var(--score-value-height, 24px)',
        rowGap: 0.5,
        width: { xs: '100%', sm: 136, md: 160 },
        maxWidth: '100%',
        justifySelf: 'end',
        minWidth: 0,
      }}>
        <Box
          component={ImageSparkIcon}
          aria-hidden="true"
          focusable="false"
          sx={{ width: { xs: 16, sm: 24, md: 28 }, height: { xs: 16, sm: 24, md: 28 }, justifySelf: 'center', color: 'secondary.main' }}
        />
        <Box
          role="progressbar"
          aria-label="Points toward next image"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={percent}
          aria-valuetext={description}
          sx={{
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid',
            borderColor: 'secondary.main',
            borderRadius: '16px',
            px: 0.5,
            minWidth: 0,
          }}
        >
          <Box aria-hidden="true" sx={{
            position: 'absolute', inset: 0, width: `${percent}%`, bgcolor: 'secondary.main', opacity: 0.22,
            transition: 'width 0.4s ease-out',
            '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
          }} />
          <Typography
            component="span"
            sx={{ position: 'relative', fontSize: { xs: 7, sm: 9, md: 10 }, lineHeight: 1, color: 'text.primary', whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}
          >
            {remaining.toLocaleString()}
            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}> left</Box>
          </Typography>
        </Box>
      </Box>
    </Tooltip>
  );
}

export default RewardProgress;
